import { render, staticRenderFns } from "./InvestorsTable.vue?vue&type=template&id=368c9bc2&"
import script from "./InvestorsTable.vue?vue&type=script&lang=js&"
export * from "./InvestorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports